import { UseQueryResult } from "react-query/types/react/types";
import { useQuery } from "react-query";
import { fetchRegionsJson } from "@api";

export const useFetchRegionJson = (): UseQueryResult<any> => {
  return useQuery([ 'static-regions' ], fetchRegionsJson, { retry: false })
}
